package org.gymly.util

/**
 * Prefijo de la API del socio según la plataforma: la web usa /api/portal; la app Android usa
 * /api/mobile/android y la de iOS /api/mobile/ios. La licencia decide por este prefijo qué canal puede entrar.
 */
expect val portalApiPrefix: String

/** Login del socio: la web usa /api/auth/client/login; las apps usan su propio prefijo. */
val portalLoginPath: String
    get() = if (portalApiPrefix.startsWith("/api/mobile/")) "$portalApiPrefix/client/login" else "/api/auth/client/login"

/** Convierte una ruta /api/portal/... que manda el servidor (p. ej. un comprobante) al prefijo de esta plataforma. */
fun toPortalChannelPath(path: String): String =
    if (path.startsWith("/api/portal/")) portalApiPrefix + path.removePrefix("/api/portal") else path
